import FormField from "../form-field";

export default class SwitchField extends FormField {
	constructor(props) {
		super(props);

		this.value = false;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('SwitchField: Root element is not defined!');
		}

		this.$input = this.$root.querySelector('.switch_input');

		if (!this.$input) {
			throw new Error('SwitchField: Input element is not defined!');
		}

		super.init();

		if (this.$input.checked) {
			this.setValue(this.$input.checked);
		}
	}

	addEventListeners() {
		this.$input.addEventListener('change', this.handleChange.bind(this));
	}

	handleChange(e) {
		this.setValue(e.target.checked);
	}

	setInitialState() {
		this.$input.checked = false;
		this.$input.dispatchEvent(new Event('change'));
	}

	setInitialValue(value) {
		this.setValue(value);
		this.$input.checked = value;
		this.$input.dispatchEvent(new Event('change'));
	}
}